import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiMapPin, FiZap } = FiIcons;
const DURATION = 10300;

function FinalChallenge({ onComplete }) {
  const [started, setStarted] = useState(false);
  const [remaining, setRemaining] = useState(DURATION);
  const [hits, setHits] = useState(0);
  const hitsRef = useRef(0);
  const finishedRef = useRef(false);

  useEffect(() => {
    if (!started) return undefined;

    const startedAt = Date.now();
    const timer = window.setInterval(() => {
      const nextRemaining = Math.max(0, DURATION - (Date.now() - startedAt));
      setRemaining(nextRemaining);

      if (nextRemaining === 0 && !finishedRef.current) {
        finishedRef.current = true;
        window.clearInterval(timer);
        onComplete(hitsRef.current);
      }
    }, 40);

    return () => window.clearInterval(timer);
  }, [onComplete, started]);

  const strike = () => {
    if (!started) setStarted(true);
    if (remaining <= 0) return;
    hitsRef.current += 1;
    setHits(hitsRef.current);
    navigator.vibrate?.(12);
  };

  return (
    <main className="screen-panel final-screen">
      <div className="final-event-banner">
        <span className="final-event-line">
          <SafeIcon icon={FiCalendar} />
          2026 年 10 月 3 日
        </span>
        <strong>大灣區詠春家文化廣場</strong>
        <span className="final-event-line">
          <SafeIcon icon={FiMapPin} />
          詠春千人匯演 · 詠春嘉年華
        </span>
      </div>

      <div className="section-heading final-heading">
        <span className="eyebrow">最終關 · 以 10.03 記住活動日</span>
        <h2>10.3 秒中線連環拳</h2>
        <p>拳由心發，肘底歸中；在活動日期化成的 10.3 秒內完成日字衝拳。</p>
      </div>

      <div className="final-play-area">
        <div className="live-hit-panel" aria-live="polite">
          <span>已完成</span>
          <strong>{hits}</strong>
          <small>下日字衝拳</small>
        </div>

        <div className="strike-zone">
          <div className="final-timer">
            <span>{(remaining / 1000).toFixed(1)}</span>
            <small>秒</small>
          </div>

          <motion.button
            className="strike-button"
            type="button"
            onClick={strike}
            whileTap={{ scale: 0.9 }}
          >
            <SafeIcon icon={FiZap} />
            <strong>{started ? '日字衝拳' : '點按起拳'}</strong>
            <span>10 月 3 日 · 以拳記日</span>
          </motion.button>
        </div>
      </div>
    </main>
  );
}

export default FinalChallenge;